import useStyles from "../styles";
import { useState } from "react";
import { Grid } from "@mui/material";
import InputGroup from "../../../components/FormComponent/InputGroup";
import Button from "../../../components/Button/Button";
import { Icon } from "@iconify/react";
import classNames from "classnames";

const BrandIdentity = () => {
  const classes = useStyles();

  const [brandColor, setBrandColor] = useState("#0065FF");

  const handleChangeBrandColor = (color) => {
    setBrandColor(color);
  };

  // eslint-disable-next-line no-console
  console.log(brandColor);

  return (
    <Grid container className={classes.bankingformbg}>
      <Grid item lg={6} md={12} sm={12} xs={12}>
        <div className={classes.brandingcontainer}>
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <div className={classes.brandflex}>
                <div className={classes.imagecontainer}>
                    E
                </div>
                <div className={classes.brandesc}>
                  <h4 className={classes.title}>Brand Logo</h4>
                  <h6 className={classes.subtitle}>This image will be displayed on your profile</h6>
                  <button className={classes.selectimage}>
                    <Icon icon="heroicons:pencil-square-solid" className={classes.editpencil} />
                    Change Brand Image
                    <input type="file" className={classes.filepicker} />
                  </button>
                </div>
              </div>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <InputGroup inputType="text" label="Company Name" name="" />
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <InputGroup inputType="text" label="Description" name="" />
            </Grid>
          </Grid>
          <div className={classes.btnspace}>
            <Button variant="primary" color="btndefault" buttonSize="medium" buttonName="Save Changes" />
          </div>
        </div>
      </Grid>
      <Grid item lg={6} md={4} sm={12} xs={12}>
        <div className={classes.brandingcontainer}>
          <h4 className={classes.title}>Choose a Brand Color</h4>
          <div className={classes.palettecontainer}>
            <div className={classNames(classes.palettewrapper, {
              [classes.blueselected]: brandColor === "#0065FF"
            })}
            onClick={() => {
              handleChangeBrandColor("#0065FF");
            }}
            >
              <div className={classNames(classes.colorpalette, classes.paletteblue)} />
            </div>

            {/* Palette Pink */}
            <div className={classNames(classes.palettewrapper,
              { [classes.pinkselected]: brandColor === "#B00074" }
            )}
            onClick={() => {
              handleChangeBrandColor("#B00074");
            }}
            >
              <div className={classNames(classes.colorpalette, classes.palettepink)} />
            </div>

            {/* Green Palette */}
            <div className={classNames(classes.palettewrapper,
              {
                [classes.greenselected]: brandColor === "#099137"
              }
            )}
            onClick={() => {
              handleChangeBrandColor("#099137");
            }}
            >
              <div className={classNames(classes.colorpalette, classes.palettegreen)} />
            </div>

            <div className={classNames(classes.palettewrapper,
              {
                [classes.yellowselected]: brandColor === "#AD6F07"
              }
            )}
            onClick={() => {
              handleChangeBrandColor("#AD6F07");
            }}
            >
              <div className={classNames(classes.colorpalette, classes.paletteyellow)} />
            </div>
          </div>
        </div>
      </Grid>
    </Grid>
  );
};

export default BrandIdentity;
